var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subway:call-1",
    clipPath: "url(#clip0_1778_39600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5544 17.5686C14.17 16.7764 13.6731 16.1999 12.8153 16.5514L11.1231 17.1796C9.76842 17.8077 9.09342 17.1796 8.41373 16.2327L5.36686 9.30456C4.98248 8.51237 5.18405 7.76706 6.04186 7.4155L8.40905 6.46862C9.26686 6.11237 9.13092 5.37175 8.74655 4.57956L6.71686 0.801436C6.33248 0.00924826 5.54498 -0.182939 4.68717 0.168623C2.97623 0.876436 1.55123 1.98737 0.632483 3.63269C-0.492517 5.64362 0.0699829 8.44206 0.294983 9.61862C0.519983 10.7952 1.30748 12.8577 2.32467 14.9717C3.34186 17.0905 4.23248 18.7546 5.02936 19.6967C5.82623 20.6389 7.73873 23.2171 10.1059 23.7936C12.0465 24.2624 14.1419 23.8686 15.8575 23.1608C16.72 22.8092 16.72 22.0639 16.3356 21.2671L14.5544 17.5686ZM23.9622 9.22487H15.6512L19.345 5.53112H16.5747L11.9575 10.1483L16.5747 14.7655H19.345L15.6512 11.0717H23.9622V9.22487Z",
    fill: "#B88D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1778_39600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.bad6f03ed57b71c027e35f448f2f41cf.svg";
export { ForwardRef as ReactComponent };